import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../service/http-service";
export class AuthGuard {
    constructor(router, httpService) {
        this.router = router;
        this.httpService = httpService;
    }
    canActivate(route, state) {
        // return true;
        if (sessionStorage.getItem('token') !== null && sessionStorage.getItem('token') !== '') {
            return true;
        }
        this.httpService.showSnackBar('error', 'Please Login To Your Account !!!');
        this.router.navigate(['/authentication/login']);
        sessionStorage.clear();
        return false;
    }
}
AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.HttpService)); }, token: AuthGuard, providedIn: "root" });
